import { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { DataFeedMapper, GraphQLTemplateAndContent, TemplateState } from '../../types';

export interface TemplateContextState {
  templateState: TemplateState;
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  dataFeeds: DataFeedMapper;
  templateAndContent: GraphQLTemplateAndContent;
  refetch: () => void;
  contactCardName: string;
  templateLocales: string[];
  isSMSLinkShorteningEnabled: boolean;
  setIsSMSLinkShorteningEnabled: (isSMSLinkShorteningEnabled: boolean) => void;
}

export const DEFAULT_TEMPLATE_CONTEXT_STATE: TemplateContextState = {
  templateState: {} as TemplateState,
  errorMessage: '',
  hasError: false,
  isLoading: true,
  dataFeeds: {},
  templateAndContent: {} as GraphQLTemplateAndContent,
  refetch: noop,
  contactCardName: '',
  templateLocales: [],
  isSMSLinkShorteningEnabled: false,
  setIsSMSLinkShorteningEnabled: noop,
};

export const TemplateContext = createContext<TemplateContextState>(DEFAULT_TEMPLATE_CONTEXT_STATE);
export const useTemplateContext = () => useContext(TemplateContext);
